const React = require('react');
const READ_MORE_SIZE = 70;

const Review = require('./review.jsx');

class ReviewList extends React.Component {
  componentDidUpdate() {
    Reverb.ReadMore.addReadMore('.product-review-description', READ_MORE_SIZE);
  }

  renderReviews = () => {
    return this.props.reviews.map((review, index) => {
      return <Review review={review} key={index} updateSuccess={this.props.updateSuccess} />;
    });
  };

  render() {
    return (
      <ul className="product-reviews-list">
        {this.renderReviews()}
      </ul>
    );
  }
}

module.exports = ReviewList;



// WEBPACK FOOTER //
// ./javascripts/components/product_reviews/list.jsx